import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgUtils } from 'tiime-expert-utils';

import { UploadFile } from '../upload-file';
import { UploadFileStatus } from '../upload-file-status.enum';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {
  @Input() currentFiles: UploadFile[];
  @Input() hasPendingUpload: boolean;

  @Output() readonly closeOverlay: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly navigate: EventEmitter<void> = new EventEmitter<void>();

  displayContent = true;

  readonly UploadFileStatus = UploadFileStatus;
  readonly trackByIndex = NgUtils.trackByIndex;

  get countPendingUploadingFiles(): number {
    return this.currentFiles.filter(
      (file: UploadFile) =>
        file.uploadStatus === UploadFileStatus.COMPLETED || file.uploadStatus === UploadFileStatus.ON_ERROR
    ).length;
  }
  get hasFilesInQueue(): boolean {
    return this.currentFiles.length > 0;
  }
  get headerDescription(): string | null {
    if (!this.currentFiles) {
      return null;
    }
    if (this.hasPendingUpload) {
      return `${this.currentFiles.length} importation${this.currentFiles.length > 1 ? 's' : ''} en cours...`;
    }
    if (this.isDoneUploading) {
      return `${this.currentFiles.length} importation${this.currentFiles.length > 1 ? 's' : ''} terminée${
        this.currentFiles.length > 1 ? 's' : ''
      }`;
    }
    return null;
  }
  get isDoneUploading(): boolean {
    return this.currentFiles.every(
      (file: UploadFile) =>
        file.uploadStatus === UploadFileStatus.COMPLETED || file.uploadStatus === UploadFileStatus.ON_ERROR
    );
  }

  emitCloseOverlay(): void {
    this.closeOverlay.emit();
  }

  emitNavigate(): void {
    this.navigate.emit();
  }

  toggleContentDisplay(): void {
    this.displayContent = !this.displayContent;
  }
}
